//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import blok from '~/mixins/blok'
export default {
  mixins: [blok],
  computed: {
    image () {
      return this.$sb.parseImage(this.blok.image)
    },
    imageClass () {
      const cls = []

      if (this.blok.overflow_image) {
        cls.push('tw-transform tw-rotate-[-15deg] tw-translate-y-6 tw--mt-5 md:tw-mt-0 md:tw-translate-y-14 tw-w-48 md:tw-w-80')
      } else if (this.blok.rotate_image) {
        cls.push('tw-transform tw-rotate-[-15deg] tw--translate-y-6')
      }

      if (!this.blok.overflow_image) {
        cls.push('tw-w-44 md:tw-w-72')
      }

      return cls
    },
    sectionClass () {
      switch (this.blok.style) {
        case 'white':
          return 'tw-bg-white'
        case 'beige':
          return 'tw-bg-cream-50'
        case 'black':
          return 'tw-bg-gray-800'
        default:
          return ''
      }
    },
    containerClass () {
      const cls = [
        this.$ui.container
      ]

      if (this.image) {
        if (this.blok.overflow_image) {
          cls.push('tw-pb-0')
        } else {
          cls.push('tw-pb-8 sm:tw-pb-16')
        }
      } else {
        cls.push('tw-pb-0 sm:tw-pb-12')
      }

      if (this.blok.overflow_image) {
        cls.push('tw-pt-16', 'sm:tw-pt-16')
      } else {
        cls.push('tw-pt-16', 'sm:tw-pt-24')
      }

      return cls
    },
    titleComponent () {
      return this.blok.title_component || 'h1'
    },
    titleClass () {
      const cls = []

      switch (this.blok.style) {
        case 'white':
          cls.push('tw-text-gray-800')
          break
        case 'beige':
          cls.push('tw-text-gray-800')
          break
        case 'black':
          cls.push('tw-text-white')
          break
      }

      if (this.blok.overflow_image) {
        cls.push('sm:tw-leading-snug lg:tw-leading-snug')
      }

      return cls
    },
    subtitleClass () {
      switch (this.blok.style) {
        case 'white':
          return 'tw-text-gray-600'
        case 'beige':
          return 'tw-text-gray-600'
        case 'black':
          return 'tw-text-gray-400'
        default:
          return ''
      }
    },
    hrClass () {
      switch (this.blok.style) {
        case 'white':
          return 'tw-border-gray-200'
        case 'beige':
          return 'tw-border-latte-300'
        case 'black':
          return 'tw-border-gray-100 tw-opacity-20'
        default:
          return ''
      }
    }
  }
}
